import React, { useState, useContext } from 'react'

import { FileUploadLogicContext } from 'components/Upload/FileUploadLogic'
import { AttachmentsContext } from 'components/Attachments/AttachmentsLogic'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import EventAttachments from 'components/Events/EventForm/EventAttachments/EventAttachments'
import { FieldArray } from 'formik'
import ErrorComponent from 'components/Errors/ErrorComponent'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'

import './event-form-attachments-module.css'

const EventFormAttachmentsModule = ({ label }) => {
    const [open, setOpen] = useState(false)

    const fileUploadContext = useContext(FileUploadLogicContext)
    const { attachments, handleRemoveAttachment } = useContext(AttachmentsContext)

    const isOpen = open || attachments.length || fileUploadContext.loading || fileUploadContext.error

    return (
        <EventFormModule className="event-form-attachments-module" expanded={open}>
            <CompactFormRow
                iconName="paperclip"
                label={label}
                onClick={() => !open && setOpen(!open)}
                expandable={!open}
                trackName="attachment"
            />
            {(isOpen) && (
                <FieldArray name="attachments">
                    {arrayHelpers => (
                        <div>
                            <EventAttachments
                                attachments={attachments}
                                onRemove={handleRemoveAttachment}
                                loading={fileUploadContext.loading}
                            />
                            {fileUploadContext.error && <ErrorComponent error={fileUploadContext.error} />}
                        </div>
                    )}
                </FieldArray>
            )}
        </EventFormModule>
    )
}

export default EventFormAttachmentsModule
